import React, { useContext } from 'react'
import { withTranslationCustom } from 'lib/i18next'
import { VEHICLE_INSPECTION_STATUS } from 'lib/utils/store/vehicle'

import { ExtendedFormikContext } from 'components/Forms/ExtendedFormik'
import EventFormModule from 'components/Events/EventForm/EventFormModules/EventFormModule'
import CompactFormRow from 'components/Forms/CompactForm/CompactFormRow/CompactFormRow'

import './event-form-inspection-trafi-data-module.pcss'

const EventFormInspectionTrafiDataModule = ({ label, t }) => {
    const { values } = useContext(ExtendedFormikContext)

    const isValid = values.trafiInspectionResult === VEHICLE_INSPECTION_STATUS.ACCEPTED

    return (
        <EventFormModule className="event-form-inspection-trafi-data-module">
            <CompactFormRow
                iconName="check-circle"
                label={label}
                trackName="inspectionResult"
            >
                <div className="event-form-inspection-trafi-data-module__result">
                    <span className={!isValid ? 'alert-text' : ''}>
                        <b>{t(`events:forms.inspectionResult.options.${values.trafiInspectionResult.toLowerCase()}`)}</b>
                    </span>
                </div>
            </CompactFormRow>
            <div className="event-form-inspection-trafi-data-module__text">
                {t('events:forms.inspectionResult.traficomText')}
            </div>
        </EventFormModule>
    )
}

export default withTranslationCustom(['events'])(EventFormInspectionTrafiDataModule)
